import { render, staticRenderFns } from "./OrderItem.vue?vue&type=template&id=741368cf&scoped=true&"
import script from "./OrderItem.ts?vue&type=script&lang=ts&"
export * from "./OrderItem.ts?vue&type=script&lang=ts&"
import style0 from "./OrderItem.vue?vue&type=style&index=0&id=741368cf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741368cf",
  null
  
)

export default component.exports